import "react-calendar/dist/Calendar.css";
import "./index.css";

import { useState } from "react";
import Calendar from "react-calendar";

const CalendarPicker = ({ selectedDate, setSelectedDate }) => {
  const [calendarOpen, setCalendarOpen] = useState(false);

  const isToday = (date) => {
    const today = new Date();

    return date.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0);
  };
  const formatDate = (date) => {
    if (isToday(date))
      return {
        weekday: false,
        dateText: `Today, ${date.toLocaleString("locale", {
          month: "long",
          day: "numeric",
        })}`,
      };
    return {
      weekday: date.toLocaleString("locale", {
        weekday: "long",
      }),
      dateText: date.toLocaleString("locale", {
        month: "long",
        day: "numeric",
        year: "numeric",
        groupingSeparator: " ",
      }),
    };
  };

  return (
    <div className="calendar-picker">
      <div className="calendar-date">
        <div
          className="date-display"
          onClick={() => setCalendarOpen(!calendarOpen)}
        >
          {formatDate(selectedDate).weekday && (
            <div className="date-weekday">
              {formatDate(selectedDate).weekday}
            </div>
          )}
          <div className={`date-text ${isToday(selectedDate) ? "today" : ""}`}>
            {formatDate(selectedDate).dateText}
            <i className="fa fa-angle-down chevron-down" />
          </div>
          
        </div>
      </div>
      <div className={`calendar ${calendarOpen ? "show" : ""}`}>
        <Calendar
          value={selectedDate}
          onChange={(value) => {
            setSelectedDate(new Date(value));
            setCalendarOpen(false);
          }}
        />
      </div>
    </div>
  );
};

export default CalendarPicker;
